import Rest from '@/services/Rest';

export default class NPSResearchService extends Rest {
  static resource = 'nps-research';
}
